<template>
    <ForkModal
        id="biometric-enroll-modal"
        ref="modal"
        dialog-class="modal-dialog-scrollable"
        :hide-header="true"
        aria-labelledby="biometric-enroll-title"
        :mobile-fullscreen="false"
        :keyboard-dismiss="true"
        @close="dismiss"
    >
        <div class="modal-body text-center py-4">
            <div class="mb-3">
                <i :class="iconGlyph" class="text-success" style="font-size: 3rem"></i>
            </div>
            <h5 id="biometric-enroll-title" class="fw-semibold mb-2">Enable {{ biometricLabel }}?</h5>
            <p class="text-muted mb-0">
                Use {{ biometricLabel }} for faster sign-in next time you open Forkto.
            </p>
        </div>
        <div class="modal-footer border-0 justify-content-center gap-2">
            <button class="btn btn-outline-secondary" @click="dismiss">Not Now</button>
            <button class="btn btn-success" @click="enroll">
                <i :class="iconGlyph" class="me-2"></i>Enable
            </button>
        </div>
    </ForkModal>
</template>

<script>
import ForkModal from "@/components/common/ForkModal.vue";

export default {
    components: { ForkModal },
    props: {
        biometryType: {
            type: Number,
            default: 0
        }
    },
    emits: ["enrolled", "dismissed"],
    computed: {
        biometricLabel() {
            // BiometryType: 1 = Touch ID, 2 = Face ID, 3 = Fingerprint, 4 = Face auth.
            if (this.biometryType === 2 || this.biometryType === 4) return "Face ID";
            if (this.biometryType === 1) return "Touch ID";
            if (this.biometryType === 3) return "Fingerprint";
            return "Biometrics";
        },
        iconGlyph() {
            // fa-portrait (face in a frame) ≈ Face ID; FA5 has no face-viewfinder
            if (this.biometryType === 2 || this.biometryType === 4) return "fas fa-portrait";
            return "fas fa-fingerprint";
        }
    },
    methods: {
        open() {
            this.$refs.modal?.open();
        },
        close() {
            this.$refs.modal?.close();
        },
        enroll() {
            this.close();
            this.$emit("enrolled");
        },
        dismiss() {
            this.close();
            this.$emit("dismissed");
        }
    }
};
</script>
